import React from 'react'
import Card from 'react-bootstrap/Card'
import englishmed from'../Images/engmedicine.jpg'
import baby from '../Images/dbaby.jpg'
import pet from '../Images/petaccess.jpg'
import vet from '../Images/vetjpeg.jpeg'
import prem from '../Images/premiumfoods.png'
import ayur from '../Images/ayurvedic.png'
import equip from '../Images/equipments.jpg'
import beaut from '../Images/Beautycare.png'
import styled from "@emotion/styled/macro";
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import '../App.css'
import { Link } from 'react-router-dom'

function Cardsection() {
    const DisplayOver = styled.div({
        transition: "background-color 350ms ease",
        boxSizing: "border-box", 
      });
    

      const Hover = styled.div({
        opacity: 0,
        transition: "opacity",
        transform: "translate3d(0,0px,0)"
        
      });

      const SubTitle = styled.h6({
        fontFamily: "mooli",
        fontWeight:'700',
        transform: "translate3d(0,50px,0)",
        transition: "transform 350ms ease",
      });
      
      const CTA = styled.a({
        position: "absolute",
        fontSize:'16px',
        fontWeight:'700',
        textDecoration:'none',
        fontFamily:'mooli',

      });

      const Background = styled.div({
        [`:hover ${DisplayOver}`]: {
          opacity:'0.4'
        },
        [`:hover ${SubTitle}`]: {
          transform: "translate3d(0,0,0)",
        },
        [`:hover ${Hover}`]: {
          opacity: 1,
        },
      });
  return (
    <>
    <div className='carddiv justify-content-evenly'>
    <Background>
        <Card className='servcard' style={{ width: '18rem' }}>
        <DisplayOver><Card.Img style={{opacity:'0.7'}} src={englishmed}/></DisplayOver>
            <Card.ImgOverlay>
                <Card.Body className='cardtit'>English Medicines</Card.Body>
                <Hover>
                   <SubTitle>Get All English Medicines at maximum discount!!</SubTitle>
                   <CTA><Link to={"/englishmedicines"} style={{textDecoration:'none'}}>More Details <i class="fa-solid fa-arrow-right"></i></Link></CTA>
                 </Hover>
            </Card.ImgOverlay>
        </Card>
    </Background>


    <Background>
        <Card className='servcard' style={{ width: '18rem' }}>
        <DisplayOver><Card.Img style={{opacity:'0.6'}} src={equip}/></DisplayOver>
            <Card.ImgOverlay>
            <Card.Body className='cardtit'>Medical Equipments</Card.Body>
                <Hover>
                   <SubTitle>All high quality Medical Equipments available!!</SubTitle>
                   <CTA><Link  to={"/medicalequipments"} style={{textDecoration:'none'}}>More Details<i class="fa-solid fa-arrow-right"></i></Link></CTA>
                 </Hover>
            </Card.ImgOverlay>
        </Card>
    </Background>


    <Background>
        <Card className='servcard' style={{ width: '18rem' }}>
        <DisplayOver><Card.Img style={{opacity:'0.6'}} src={ayur}/></DisplayOver>
            <Card.ImgOverlay>
            <Card.Body className='cardtit'>Ayurvedic Products</Card.Body>
                <Hover>
                   <SubTitle>All Avurvedic products Available</SubTitle>
                   <CTA><Link  to={"/ayurvedic"} style={{textDecoration:'none'}}>More Details<i class="fa-solid fa-arrow-right"></i></Link></CTA>
                 </Hover>
            </Card.ImgOverlay>
        </Card>
    </Background>


    <Background>
        <Card className='servcard' style={{ width: '18rem' }}>
        <DisplayOver><Card.Img style={{opacity:'0.7'}} src={baby}/></DisplayOver>
            <Card.ImgOverlay>
            <Card.Body className='cardtit'>Baby Care Products</Card.Body>
                <Hover>
                   <SubTitle>All Premium baby care products available</SubTitle>
                   <CTA><Link to={"/babycare"} style={{textDecoration:'none'}}>More Details<i class="fa-solid fa-arrow-right"></i></Link></CTA>
                 </Hover>
            </Card.ImgOverlay>
        </Card>
    </Background>



    </div>
    <div className='carddiv  justify-content-evenly mt-5'>

    <Background>
        <Card className='servcard' style={{ width: '18rem' }}>
        <DisplayOver><Card.Img style={{opacity:'0.6'}} src={beaut}/></DisplayOver>
            <Card.ImgOverlay>
            <Card.Body className='cardtit'>Skin Care</Card.Body>
                <Hover>
                   <SubTitle>All Skin care products available at maximum discount!</SubTitle>
                   <CTA><Link to={"/beauty"} style={{textDecoration:'none'}}>More Details<i class="fa-solid fa-arrow-right"></i></Link></CTA>
                 </Hover>
            </Card.ImgOverlay>
        </Card>
    </Background>

    <Background>
        <Card className='servcard' style={{ width: '18rem' }}>
        <DisplayOver><Card.Img style={{opacity:'0.6'}} src={vet}/></DisplayOver>
            <Card.ImgOverlay>
            <Card.Body className='cardtit'>Veterinary Medicines</Card.Body>
                <Hover>
                   <SubTitle>All Veterinary medicines Available</SubTitle>
                   <CTA><Link to={"/veterinary"} style={{textDecoration:'none'}}>More Details<i class="fa-solid fa-arrow-right"></i></Link></CTA>
                 </Hover>
            </Card.ImgOverlay>
        </Card>
    </Background>
    
    <Background>
        <Card className='servcard' style={{ width: '18rem',height:'12rem' }}>
        <DisplayOver><Card.Img style={{opacity:'0.7'}} src={pet}/></DisplayOver>
            <Card.ImgOverlay>
            <Card.Body className='cardtit'>Pet Accessories</Card.Body>
                <Hover>
                   <SubTitle>All Pet Accessories available at maximum discount!</SubTitle>
                   <CTA><Link  to={"/petaccessories"} style={{textDecoration:'none'}}>More Details<i class="fa-solid fa-arrow-right"></i></Link></CTA>
                 </Hover>
            </Card.ImgOverlay>
        </Card>
    </Background>

    <Background>
        <Card className='servcard' style={{width: '18rem', height:'12rem' }}>
        <DisplayOver><Card.Img style={{opacity:'0.7'}} src={prem}/></DisplayOver>
            <Card.ImgOverlay>
            <Card.Body className='cardtit'>Premium Pet foods</Card.Body>
                <Hover>
                   <SubTitle>All Premium pet foods are available!</SubTitle>
                   <CTA><Link to={"/premiumpet"} style={{textDecoration:'none'}}>More Details<i class="fa-solid fa-arrow-right"></i></Link></CTA>
                </Hover>
            </Card.ImgOverlay>
        </Card>
    </Background>
</div>

</>
  )
}

export default Cardsection